module.exports = __webpack_public_path__ + "img/image-moon.56ed2a5e.png";